import { render, staticRenderFns } from "./SettingsBasicBlock.vue?vue&type=template&id=278954f1&scoped=true&"
import script from "./SettingsBasicBlock.vue?vue&type=script&lang=js&"
export * from "./SettingsBasicBlock.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBasicBlock.vue?vue&type=style&index=0&id=278954f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278954f1",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/SettingsBasicBlock.vue
// module id = null
// module chunks = 